import { render, staticRenderFns } from "./2020-11-11.vue?vue&type=template&id=1df14ee4&scoped=true&"
import script from "./2020-11-11.vue?vue&type=script&lang=ts&"
export * from "./2020-11-11.vue?vue&type=script&lang=ts&"
import style0 from "./2020-11-11.vue?vue&type=style&index=0&id=1df14ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df14ee4",
  null
  
)

export default component.exports